import { IThanhPhanThi } from "../../../model/response/category/IThanhPhanThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThanhPhanThiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IThanhPhanThi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IThanhPhanThi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IThanhPhanThi,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
};

export const eThanhPhanThiActionIds = generateActionTypeIds(eThanhPhanThiActionsObj, "THANH_PHAN_THI");
export type IThanhPhanThiActionTypes = IGenericActionType<typeof eThanhPhanThiActionsObj, "THANH_PHAN_THI">;